function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnPageTop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  "data-name": "bg_000_7%",
  rx: 20,
  style: {
    opacity: 0.07
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  rx: 19,
  style: {
    fill: "#fff"
  },
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  style: {
    fill: "transparent"
  },
  transform: "translate(8 8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.1 22.694 6.051-6.051 6.049 6.051",
  "data-name": "Path 458",
  style: {
    fill: "none",
    stroke: "#222",
    strokeLinejoin: "round",
    strokeWidth: "1.3px"
  },
  transform: "translate(-.15 -.143)"
}));
export default SvgBtnPageTop;